import api from "./axios";
import { SPaginatedCompanies, SCompanyCreate, SCompanyOut, SCompanyUpdate } from "../types/companies";

type CompanyOrderField = "id" | "company_name" | "subscription_expires_on";

export async function listCompanies(params: {
  page?: number;
  per_page?: number;
  order_by?: CompanyOrderField | null;
  order_dir?: "asc" | "desc" | null;
  hide_expired_subscription?: boolean | null;
  show_archived?: boolean | null;
  q?: string | null;
} = {}) {
  const { data } = await api.get<SPaginatedCompanies>("/companies/", {
    params: {
      page: params.page ?? 1,
      per_page: params.per_page ?? 20,
      q: params.q?.trim() || null,
      order_by: params.order_by ?? null,
      order_dir: params.order_dir ?? null,
      hide_expired_subscription: params.hide_expired_subscription ?? null,
      show_archived: params.show_archived ? true : null,
    },
  });
  return data;
}

export async function getCompany(companyId: number) {
  const { data } = await api.get<SCompanyOut>(`/companies/${companyId}`);
  return data;
}

export async function createCompany(payload: SCompanyCreate) {
  const { data } = await api.post<SCompanyOut>("/companies/", payload);
  return data;
}

export async function updateCompany(companyId: number, payload: SCompanyUpdate) {
  const { data } = await api.patch<SCompanyOut>(`/companies/${companyId}`, payload);
  return data;
}

export async function deleteCompany(companyId: number) {
  const { data } = await api.delete(`/companies/${companyId}`);
  return data;
}

export async function archiveCompany(companyId: number) {
  const { data } = await api.post<SCompanyOut>(`/companies/${companyId}/archive`);
  return data;
}

export async function restoreCompany(companyId: number) {
  const { data } = await api.delete<SCompanyOut>(`/companies/${companyId}/archive`);
  return data;
}
